import React, {useContext, useEffect, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {AgentContext} from "../context/agent-context.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";
import TreePermissions from "../../../../../components/tree-permissions/tree-permissions.jsx";
import roleService from "../../../../../services/web/role-service.js";
import Button from "../../../../../components/button/button.jsx";

const UserPermission = () => {
    const {groupsSelected, setGroupsSelected, rolesSelected, setRolesSelected, userInfo, setChanges, user} = useContext(AgentContext)
    const [open, setOpen] = useState(false);

    const {data} = useQuery({
        queryFn: () => {
            const formData = new FormData();
            formData.append("roleId", JSON.stringify(rolesSelected.map(r => r.value)));

            return roleService.permissionsByRoleId(formData).then(data => data.data)
        },
        queryKey: ['permissionsByRoleId', {rolesSelected}],
    });

    return (
        <>
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-6">
                    <SelectComponent
                        isDisabled={!user.user.status}
                        value={rolesSelected}
                        options={userInfo?.roles ?? []}
                        label={"Funções"}
                        onChange={(value) => {
                            setRolesSelected(value);
                            setChanges('user');
                        }}
                        isMulti
                    />
                </div>
                <div className="col-span-6">
                    <SelectComponent
                        isDisabled={!user.user.status}
                        value={groupsSelected}
                        options={userInfo?.groups ?? []}
                        label={"Grupos de operação"}
                        onChange={(value) => {
                            setGroupsSelected(value);
                            setChanges('user');
                        }}
                        isMulti
                    />
                </div>
            </div>

            <Button className={"mt-3"} disabled={!data?.permissions.length} onClick={() => setOpen(true)}>
                {data?.permissions.length ? `Ver ${data.permissions.length} permissões selecionadas` : "Não há permissões"}
            </Button>

            <Modal isCloseClick={false} open={open} setOpen={() => setOpen(false)} centered size="xl" backdrop="static" keyboard={false} title={"Permissões selecionadas"}>

                <Modal.Body className="p-2">
                    <div className={"overflow-auto"} style={{maxHeight: "calc(100vh - 285px)" }}>
                        <TreePermissions
                            permissionsSelected={data?.permissions ?? []}
                            lanesSelected={data?.lanes}
                            maintenanceSelected={data?.maintenance}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default UserPermission;